<!-- <h1>This is angular app!!!</h1> -->

<!-- <ng4-loading-spinner [timeout]="2000000"> </ng4-loading-spinner> -->

<ng-container *ngIf="layoutName == 'layoutTwo'; else layoutOne">
  <!-- <app-header></app-header> -->
  <router-outlet></router-outlet>
  <!-- <app-footer></app-footer> -->
</ng-container>

<ng-template #layoutOne>
  <ng-container>
    <div class="gray-bg">
      <router-outlet></router-outlet>
    </div>
  </ng-container>
</ng-template>
